<template>
     <div class="text-separator">
        <span class="separator-line"></span>
        <span class="separator-text">or</span>
        <span class="separator-line"></span>
    </div>
</template>
<style lang="scss" scoped>
.text-separator {
    display: flex;
    align-items: center;
    text-align: center;
    padding-left: 35px;
    padding-right: 35px;
}
.separator-line {
    flex: 1;
    border-top: 1px solid #B9B3AE;
}
.separator-text {
    padding: 0 20px;
    text-transform: uppercase;
    font-size: 0.85rem;
    white-space: nowrap;
    color: #B9B3AE;
}

</style>